import LaravelEcho from 'laravel-echo';

window.Pusher = require('pusher-js');

let echo = {};

const pusherKeyMeta = document.head.querySelector('meta[name="pusher-key"]');
const pusherHostAddressMeta = document.head.querySelector('meta[name="pusher-host-address"]');
const pusherPathMeta = document.head.querySelector('meta[name="pusher-path"]');
const pusherPortMeta = document.head.querySelector('meta[name="pusher-port"]');
const pusherUseTLSMeta = document.head.querySelector('meta[name="pusher-use-tls"]');

if (pusherKeyMeta && pusherHostAddressMeta && pusherPathMeta && pusherPortMeta && pusherUseTLSMeta) {
  const pusherKey = pusherKeyMeta.content;
  const pusherHostAddress = pusherHostAddressMeta.content;
  const pusherPath = pusherPathMeta.content;
  const pusherPort = pusherPortMeta.content;
  const pusherUseTLS = pusherUseTLSMeta.content === 'true';

  try {
    echo = new LaravelEcho({
      broadcaster: 'pusher',
      key: pusherKey,
      wsHost: pusherHostAddress,
      wsPath: pusherPath,
      wsPort: pusherPort,
      wssPort: pusherPort,
      cluster: '',
      forceTLS: pusherUseTLS,
      encrypted: true,
      enableStats: false,
      enabledTransports: ['ws', 'wss']
    });
    console.log('Echo instantiated');
  } catch (e) {
    console.error('Error instantiating Echo', e);
  }
} else {
  console.log('Pusher meta tags not found.');
}

export const Echo = echo;
